<div class="stepper-container">
  <div class="stepper">
    <div
      class="step-item"
      *ngFor="let step of stepsWithStatus"
      [class.step-active]="getStepStatus(step.id) === 'active'"
      [class.step-completed]="getStepStatus(step.id) === 'completed'"
      [class.step-pending]="getStepStatus(step.id) === 'pending'"
      (click)="onStepClick(step)"
    >
      <div class="step-circle">
        <ng-container *ngIf="getStepStatus(step.id) === 'completed'">
          <mat-icon>check_circle</mat-icon>
        </ng-container>
        <ng-container *ngIf="getStepStatus(step.id) !== 'completed'">
          <mat-icon>{{ step.icon }}</mat-icon>
        </ng-container>
      </div>
      <span class="step-label">{{ step.label }}</span>
      <div class="step-connector" *ngIf="step.id < steps.length"></div>
    </div>
  </div>
</div>
